import React from 'react';
import { object, string } from 'prop-types';
import classNames from 'classnames';
import css from './RippleSpinner.module.css';

function RippleSpinner(props) {
  const { className, style } = props;
  return <div className={classNames(css.spinner, className)} style={style} />;
}

RippleSpinner.defaultProps = {
  className: null,
  style: null,
};

RippleSpinner.propTypes = {
  className: string,
  style: object,
};

export default RippleSpinner;
